import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 476.213 476.213",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M476.213 223.107H57.427l94.393-94.394-21.213-21.213L0 238.106l130.607 130.608L151.82 347.5l-94.393-94.393h418.786z" })
});
export default SvgArrowLeftSimple;
